export const academicPositionList = [
  {
    time: "2020-present",
    title: "Assistant Professor",
    company: "Department of Chemistry, The University of Texas at San Antonio",
    location: "San Antonio, TX",
  },
];

export const educationList = [
  {
    time: "2016-2020",
    location: "Harvard University",
    description: "Postdoc and Research Associate",
    logo: "/logos/Harvard_logo.jpg",
  },
  {
    time: "2011-2016",
    location: "State University of New York at Stony Brook",
    description: "Ph.D. in Chemistry",
    logo: "/logos/Stony_Brook_University_seal.jpg",
  },
  {
    time: "2007-2011",
    location: "Nanjing University",
    description: "B.Sc. in Chemistry",
    logo: "/logos/Nanjing_University_Logo.jpg",
  },
];

export const awardList = [
  {
    time: "2020",
    description: "The University of Texas System Rising STARs award"
  },
  {
    time: "2019",
    description: "Best Overall Abstract Presentation, 2nd NanoScientific Symposium on SPM"
  },
  {
    time: "2019",
    description: "Honorable Mention for the International Precious Metals Institute Award"
  },
  {
    time: "2016",
    description: "John Marburger III Fellowship for Science, Engineering and Mathematics"
  },
  {
    time: "2015",
    description: "Kokes Award for the 24th North American Catalysis Society Meeting"
  },
];

export const courseList = [
  {
    id: "CHE 1103",
    description: "General Chemistry"
  },
  {
    id: "CHE 6973/4953",
    description: "Surface Characterization"
  },
  {
    id: "CHE 3804",
    description: "Molecular Thermodynamics"
  },
];

export const xfNewsList = [
  {
    time: "Oct 23, 2023",
    title: "DOE grant enables UTSA professor Xu to study a novel material with environmental benefits",
    link: "https://www.utsa.edu/today/2023/10/story/fang-xu-awarded-grant-for-chemistry-research.html"
  },
  {
    time: "Aug 1, 2022",
    title: "UTSA, SwRI collaborate to make more efficient storage materials for hydrogen fuels",
    link: "https://www.utsa.edu/today/2022/08/story/utsa-and-swri-collaborate-for-new-hydrogen-fuels-project.html"
  },
];